"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-default-export */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_router_1 = require("react-router");
const categories_1 = require("./categories");
const all_apps_1 = require("./all-apps");
const Apps = (props) => {
    const TgObj = sdk_1.default;
    const navigate = (0, react_router_1.useNavigate)();
    const handleBack = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        TgObj.BackButton.hide();
        navigate('/');
    };
    (0, react_1.useLayoutEffect)(() => {
        window.document.body.scrollTo(0, 0);
    }, []);
    (0, react_1.useEffect)(() => {
        TgObj.BackButton.show();
        TgObj.BackButton.onClick(handleBack);
        return () => TgObj.BackButton.offClick(handleBack);
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { paddingBottom: '81px' }, children: [(0, jsx_runtime_1.jsx)(categories_1.Categories, { isTg: props.isTg, selectedLanguage: props.selectedLanguage, data: props.data, isLoading: props.isLoading }), (0, jsx_runtime_1.jsx)(all_apps_1.AllApps, { isTg: props.isTg, selectedLanguage: props.selectedLanguage, data: props.data, isLoading: props.isLoading })] }));
};
exports.default = Apps;
